module.exports = __webpack_public_path__ + "img/bg6.13a3ceee.png";